import { Box, Button, Grid, createStyles, makeStyles } from '@material-ui/core';
import { ExpandLess as ExpandLessIcon } from '@material-ui/icons';
import { useCallback, useEffect } from 'react';

// Data Layer
import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import { useNetworkObserver } from 'data-layer-cr/dist/network';

// Design-system
import {
  FormInputProps,
  FormValueTypes,
  SearchableDropDown,
  colors,
} from 'design-system';

// Models
import CatalogItem from '../../../../../../models/helperTypes/CatalogItem';

// Redux
import { REQUEST_BRANDS } from '../../../../../../store/catalogs/requestIdentifiers';

// General
import { NetworkIndicator } from '../../../../../General';

const makeDropDownBrandStyle = makeStyles(() =>
  createStyles({
    buttonSeeAllBrands: {
      color: colors.bright_turquoise,
    },
    fontButtonSeeAllBrands: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '16px',
      lineHeight: '19px',
    },
  }),
);

type PropsDropDownBrand = {
  updateBrandState: (brandCode?: string, brandID?: number) => void;
  setShowPreferredBrands: (preferedBrand: boolean) => void;
  isMobile: boolean;
  isCommonPlan: boolean;
  showPreferredBrands: boolean;
  getModelsAction: (brandID: number) => void;
  getInputProps: (
    inputName: string,
  ) => FormInputProps<FormValueTypes, FormValueTypes>;
  carBrandFieldName: string;
  brandsList: CatalogItem[];
  disabled: boolean;
};

const DropDownBrand = ({
  brandsList,
  carBrandFieldName,
  getInputProps,
  getModelsAction,
  isCommonPlan,
  isMobile,
  setShowPreferredBrands,
  updateBrandState,
  showPreferredBrands,
  disabled,
}: PropsDropDownBrand): JSX.Element => {
  const classes = makeDropDownBrandStyle();
  const requestBrands = useNetworkObserver(REQUEST_BRANDS);

  const onClickSeePreferredBrand = useCallback(() => {
    updateBrandState();
    setShowPreferredBrands(true);
  }, [updateBrandState, setShowPreferredBrands]);

  const OnChangeBrand = useCallback(
    (val: CatalogItem) => {
      const catalogSelected = val.Object as GeneralCatalogItem;
      updateBrandState(val.Value, catalogSelected.id);
    },
    [updateBrandState],
  );

  // Selects automatically if there's only one brand, this works in conjunction with selectedBrandFound
  // and get all models by branch id

  useEffect(() => {
    const brandValue = getInputProps(carBrandFieldName).value;
    if (brandsList.length === 1 && brandValue !== brandsList[0].Value) {
      getInputProps(carBrandFieldName).onChange(brandsList[0].Value);
      const { id } = brandsList[0].Object as GeneralCatalogItem;
      getModelsAction(id);
    }
  }, [getInputProps, brandsList, carBrandFieldName, getModelsAction]);

  return (
    <>
      {!isMobile && isCommonPlan && showPreferredBrands && (
        <Grid item xs={12}>
          <Box display="flex" justifyContent="center">
            <Button
              data-testid="button-show-featured-brand"
              className={classes.buttonSeeAllBrands}
              onClick={onClickSeePreferredBrand}
              endIcon={<ExpandLessIcon style={{ fontSize: 25 }} />}
            >
              <span className={classes.fontButtonSeeAllBrands}>
                Ver marcas destacadas
              </span>
            </Button>
          </Box>
        </Grid>
      )}
      <Grid item xs={12} data-testid="drop-down-select-card">
        {requestBrands !== 'requesting' && (
          <SearchableDropDown
            inputId="sales-web-dropdown-carbrand"
            inputName={carBrandFieldName}
            inputLabel="Marca"
            defaultValue={getInputProps(carBrandFieldName).value as string}
            options={brandsList}
            inputError={getInputProps(carBrandFieldName).error}
            inputErrorMessage={getInputProps(carBrandFieldName).errorText}
            onChange={OnChangeBrand}
            isDisabled={disabled}
          />
        )}
        <NetworkIndicator
          data-testid="car-brand-loading"
          variant="horizontal"
          requesting={requestBrands === 'requesting'}
          message="Obteniendo marcas..."
        />
      </Grid>
    </>
  );
};

export default DropDownBrand;
